var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOrderItemWaiting(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 27,
    viewBox: "0 0 26 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_360_2391)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M3.95508 21.2676C7.42695 19.1009 9.16341 16.9342 9.16341 14.7676C9.16341 11.5176 8.12174 11.5176 7.08008 11.5176C6.03841 11.5176 4.96341 12.693 4.99674 14.7676C5.03216 16.9862 6.72383 17.8843 7.60091 19.1009C9.16341 21.2676 10.2051 21.8092 11.2467 20.1842C11.9415 19.1009 12.4624 18.1985 12.8092 17.4759C13.8509 20.0033 15.2395 21.2676 16.9759 21.2676H19.5801",
    stroke: "black",
    strokeWidth: 1.925,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M21.6635 19.1003V6.10026C21.6635 4.88584 20.7479 3.93359 19.5802 3.93359C18.4125 3.93359 17.4968 4.88584 17.4968 6.10026V19.1003L19.5802 21.2669L21.6635 19.1003Z",
    stroke: "black",
    strokeWidth: 1.925,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M17.4968 8.26758H21.6635",
    stroke: "black",
    strokeWidth: 1.925,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_360_2391"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 26,
    fill: "white",
    transform: "translate(0.830078 0.683594)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderItemWaiting);
export default __webpack_public_path__ + "static/media/orderItemWaiting.d3cc35e360d89abb7ebacdaa8e278ec1.svg";
export { ForwardRef as ReactComponent };